/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { generateCacheKey } from '@msdyn365-commerce-modules/retail-actions';
import { ICommerceApiSettings } from '@msdyn365-commerce/core';
import { IPromiseDateEntity } from './DataServiceEntities.g';
import { getAllowedDatesAsync } from './DataActionExtension.g';

/**
 * GetAllowedDays Input Action
 */
export class GetAllowedDaysInput implements Msdyn365.IActionInput {
    public zipCode: string;
    public route: string;
    private readonly apiSettings: ICommerceApiSettings;
    public constructor(zipCode: string, route: string, apiSettings: ICommerceApiSettings) {
        this.zipCode = zipCode;
        this.route = route;
        this.apiSettings = apiSettings;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () =>
        generateCacheKey(this.apiSettings, { key: 'ZipCode', value: this.zipCode }, { key: 'Route', value: this.route });
    public getCacheObjectType = () => 'IPromiseDateEntity';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetAllowedDaysData {
    text: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const DateofDeliveryInput = (args: Msdyn365.ICreateActionContext<{ zipCode: string; route: string }>): Msdyn365.IActionInput => {
    return new GetAllowedDaysInput(args.config?.zipCode || '', args.config?.route || '', args.requestContext.apiSettings);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function getAllowedDays(input: GetAllowedDaysInput, ctx: Msdyn365.IActionContext): Promise<IPromiseDateEntity> {
    const response = await getAllowedDatesAsync({ callerContext: ctx }, input.zipCode, input.route);
    return Promise.resolve(response);
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IPromiseDateEntity>>getAllowedDays,
    // TODO: Give your data action a unique id
    id: 'GetAllowedDays',
    input: DateofDeliveryInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
